import { createAction } from 'redux-actions';
import documentTypes from './types';

//documents
export const getData = createAction(documentTypes.GET_DOCUMENTS);
export const dataReceived = createAction(documentTypes.DOCUMENTS_SUCCESS);
export const dataError = createAction(documentTypes.DOCUMENTS_ERROR);
export const originalDocuments = createAction(documentTypes.ORIGINAL_DOCUMENTS_DATA)

export const getDetail = createAction(documentTypes.GET_DOCUMENT_DETAIL);
export const dataDetailReceived = createAction(documentTypes.DOCUMENT_DETAIL_SUCCESS);
//filters
export const categoriesReceived = createAction(documentTypes.CATEGORIES_SUCCESS);
export const setDetailPageMun = createAction(documentTypes.DETAIL_PAGE_MUN);

export const setDocumentTypesCount = createAction(documentTypes.SET_DOCUMENT_TYPES);



// WEBPACK FOOTER //
// ./src/datahub/actions.js